import React from 'react'
import PropTypes, { array, number } from 'prop-types'

import { usePathname } from 'next/navigation'

import { BLOCKCHAIN, CTO } from 'Constants/Paths'
import { SWIPER_SCROLLBAR_DATA } from 'Constants/Swipers'

import { Container, Drag } from './styles'

function SwiperScrollbar({ modifier, width }) {
  const pathname = usePathname()
  const secondary = pathname === BLOCKCHAIN || pathname === CTO

  return (
    <Container
      className={`${SWIPER_SCROLLBAR_DATA.el}${modifier}`}
      width={width}
    >
      <Drag
        className={`${SWIPER_SCROLLBAR_DATA.dragClass}${modifier}`}
        pink={secondary}
      />
    </Container>
  )
}

SwiperScrollbar.defaultProps = {
  modifier: '',
}

SwiperScrollbar.propTypes = {
  modifier: PropTypes.string,
  width: PropTypes.oneOfType([number, array]).isRequired,
}

export default SwiperScrollbar
